import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';

import { Workflows } from '../../../tracking/tracking-constants';
import { WorkflowSteps, useTrackWorkflow } from '../../../tracking/use-workflow-tracking';
import Global from '../../../store/global-selectors';

export const sources = {
  ONBOARDING_PAGE: 'ONBOARDING_PAGE',
  ONBOARDING_PAGE_STORE_TILE: 'ONBOARDING_PAGE_STORE_TILE',
  SETTINGS_PAGE: 'SETTINGS_PAGE',
  ORDERS_GRID_EMPTY_STATE: 'ORDERS_GRID_EMPTY_STATE',
  PREMIUM_INTEGRATIONS_CARD: 'PREMIUM_INTEGRATIONS_CARD',
  ADD_ON_MARKETPLACE_PAGE: 'ADD_ON_MARKETPLACE_PAGE',
  PAYMENT_AND_SUBSCRIPTIONS_PAGE: 'PAYMENT_AND_SUBSCRIPTIONS_PAGE',
  HOME_PAGE_ONBOARDING_STEP: 'HOME_PAGE_ONBOARDING_STEP',
  HOME_PAGE_PRIMARY_ACTIONS_CONNECT_STORE: 'HOME_PAGE_PRIMARY_ACTIONS_CONNECT_STORE',
  GETTING_STARTED_GUIDE: 'GETTING_STARTED_GUIDE',
};

export const stepNames = {
  STORE_SPECIFIC_SETUP_MODAL: 'STORE_SPECIFIC_SETUP_MODAL',
  SELECT_MARKETPLACE_MODAL: 'SELECT_MARKETPLACE_MODAL',
};

export const useTrackMarketplaceConnection = () => {
  const trackEvent = useTrackWorkflow(Workflows.MARKETPLACE_CONNECTION_FLOW);
  const allSellerStores = useSelector(Global.selectSellerStores);
  const isFirstMarketplaceConnection = useMemo(() => !allSellerStores?.filter((m) => m?.marketplaceId !== 0).length, [allSellerStores]);
  return useCallback(
    (eventType, metadata = {}) => {
      const fullMetadata = eventType === WorkflowSteps.START ? { ...metadata, isFirstMarketplaceConnection } : metadata;
      trackEvent(eventType, fullMetadata);
    },
    [isFirstMarketplaceConnection, trackEvent],
  );
};
